import React, { useState, useCallback, useEffect } from 'react';
import { Chart, Series, Legend, ValueAxis, CommonSeriesSettings, Tooltip } from 'devextreme-react/chart';
import PieChart, {
  Legend as PCLegend,
  Series as PCSeries,
  Tooltip as PCTooltip,
  Label,
  Connector,
} from 'devextreme-react/pie-chart';
import { groupBy } from '../../utils/miscUtil';
import { TagBox } from 'devextreme-react/tag-box';

const palette = ["rgba(20, 77, 109, 1)", "rgba(236, 80, 32, 1)", "rgba(92, 194, 215, 1)", "rgba(0, 162, 200, 1)", "rgba(20, 77, 109, 0.4)", "rgba(236, 80, 32, 0.4)", "rgba(92, 194, 215, 0.4)", "rgba(0, 162, 200, 0.4)"]

export default function ESGTCFDMaturity(props) {
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [selectedCompaniesList, setSelectedCompaniesList] = useState([]);
  const [scenarioCompaniesData, setScenarioCompaniesData] = useState([]);
  const [scenarioDisclosingData, setScenarioDisclosingData] = useState([]);
  const [riskData, setRiskData] = useState([]);
  const [scenarioTypeData, setScenarioTypeData] = useState([]);

  useEffect(() => {
    var fd = [];
    var fd1 = [];
    var i=0;

    fd1 = groupBy(props.data, 'company_name')
    setAllCompaniesList(Object.keys(fd1).sort())

    var originalData = props.data
    if (selectedCompaniesList.length) {
      originalData = originalData.filter((it) => selectedCompaniesList.includes(it['company_name']));
    }

    fd = originalData.filter((e) => {return e["Identifier"]==="194" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "NR"
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setScenarioCompaniesData(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="195" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "NR"
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setScenarioDisclosingData(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="174" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "NR"
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setRiskData(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="196" && e["year"] ===(parseInt(props.year)-1).toString() && e["value"]});
    fd1 = {}
    fd.map((it) => {
      if (it.value) {
        let stl = it.value.replaceAll(';', ',').split(",")
        for (i=0; i<stl.length; i++) {
          if (fd1[stl[i].trim()] === undefined) {
            fd1[stl[i].trim()] = {val:0, companies: []}
          }
          fd1[stl[i].trim()].val = fd1[stl[i].trim()].val + 1
          fd1[stl[i].trim()].companies.push(it.company_name)
        }
      }
    })
    
    fd = Object.keys(fd1).map((key) => ({name: key, val: fd1[key].val, companies: fd1[key].companies}));
    setScenarioTypeData(fd);

  }, [props.data, props.year, selectedCompaniesList]);

  const onCompaniesChanged = useCallback((e) => {
    setSelectedCompaniesList(e.value);
  }, [setSelectedCompaniesList])

  const customizeTooltip = useCallback((pointInfo) => {
        var txt = ''
        txt = `<div><div class="tooltip-header">${pointInfo.argumentText}: ${pointInfo.valueText}</div><div class="tooltip-body">${pointInfo.point.data.companies.join(", ")}</div></div>`
        return {
          html: txt,
        }
      }, []);
  
    const customizeTooltip2 = useCallback((pointInfo) => {
      var txt = ''
      txt = `<div><div class="tooltip-header">${pointInfo.argumentText}<br/>${pointInfo.seriesName} : ${pointInfo.valueText}</div><div class="tooltip-body">${pointInfo.point.data["companies"].join(", ")}</div></div>`
      return {
        html: txt,
      }
    }, []);

  return (
    <>
    <h4>TCFD Maturity in {parseInt(props.year)-1} </h4>
    <div className="d-flex flex-row">
      <TagBox
          dataSource={allCompaniesList}
          value={selectedCompaniesList}
          showDropDownButton={true}
          width="100%"
          activeStateEnabled={true}
          multiline={false}
          showSelectionControls={true}
          onValueChanged={onCompaniesChanged}
          label={"Company"}
          labelMode="floating"
          placeholder={"Select Companies"}
      />
    </div>
    <hr className={'mb-4'}/>

    <div className="d-flex flex-column justify-content-between">
      <h5>Scenario Analysis (TCFD)</h5>
      <div className="d-flex flex-row w-100">
        <div className="d-flex flex-column justify-content-between" style={{width:"50%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Companies Conducting Scenario Analysis"}
            palette={palette}
            dataSource={scenarioCompaniesData}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true}>
                <Connector visible={true} />
              </Label>
            </PCSeries>
            <PCLegend margin={0} horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
        <div className="d-flex flex-column justify-content-between" style={{width:"50%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Companies Disclosing Scenarios Used"}
            palette={palette}
            dataSource={scenarioDisclosingData}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true}>
                <Connector visible={true} />
              </Label>
            </PCSeries>
            <PCLegend margin={0} horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
      </div>
      <hr className={'mb-4'}/>
      <h5>Physical Risk Assessment</h5>
      <div className="d-flex flex-row w-100 justify-content-center">
        <PieChart
          id="pie"
          type="doughnut"
          palette={palette}
          dataSource={riskData}
          resolveLabelOverlapping={"shift"}
        >
          <PCSeries argumentField="name">
            <Label visible={true}>
              <Connector visible={true} />
            </Label>
          </PCSeries>
          <PCLegend margin={0} horizontalAlignment="center" verticalAlignment="bottom" />
          <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
          </PCTooltip>
        </PieChart>
      </div>
      <hr className={'mb-4'}/>
      <h5>Type of Scenarios Used in Scenario Analysis</h5>
      <Chart
        id="chart"
        dataSource={scenarioTypeData}
      >
        <CommonSeriesSettings
          argumentField="name"
        >
        </CommonSeriesSettings>
        <Series
          type="stackedbar"
          valueField="val"
          name="Value"
          color="rgba(20, 77, 109, 0.8)"
        >
        </Series>
        <ValueAxis showZero={true} />
        <Legend
          visible={false}
          rowCount={1}
          verticalAlignment="bottom"
          horizontalAlignment="center"/>
        <Tooltip
          enabled={true}
          customizeTooltip={customizeTooltip2}
        />
      </Chart>
    </div>
    </>
  );
}
